// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qQ30","right":"styles_right__ZEkyC"};